import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { storeApi } from '@services'

export const fetchStore = createAsyncThunk(
  'store/fetchStore',
  async (id: string) => {
    const response = await storeApi.fetchStore(id)
    return response.data
  }
)

export const fetchVideoGoLiver = createAsyncThunk(
  'store/fetchVideoGoLiver',
  async (params: any) => {
    const response = await storeApi.fetchVideoGoLiverByStoreId(params)
    return response
  }
)

export const fetchStoreVideoGoLiverSummary = createAsyncThunk(
  'store/fetchStoreVideoGoLiverSummary',
  async (params: any) => {
    const response = await storeApi.fetchStoreVideoGoLiverSummary(params)
    return response.data
  }
)

export const fetchCurrentLocation = createAsyncThunk(
  'store/fetchCurrentLocation',
  async () => {
    const response = await getPosition()
    return response
  }
)

const getPosition = () => (
  new Promise((res, rej) => {
    navigator.geolocation.getCurrentPosition(res, rej)
  })
)

const initialState = {
  storeDetails: {} as any,
  isLoading: false,
  hasNextPage: false,
  videoGoLiver: { data: [], pageIndex: 0, pageSize: 0, totalRecords: 0, hasNextPage: false, hasPreviousPage: false },
  currentLocation: {} as any,
  videos: [] as any,
  page: 1,
  countLiked: 0,
  countWantToTry: 0,
  countWantToEat: 0
}

const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setPage: (state, action) => {
      state.page = action.payload
    },
    updateViewVideo: (state, action) => {
      const video = action.payload
      const videoIndex = state.videos.findIndex((v: any) => v.id === video.id)
      state.videos[videoIndex] = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchStore.fulfilled, (state, action) => {
      state.storeDetails = action.payload
    })
    builder.addCase(fetchVideoGoLiver.fulfilled, (state, action) => {
      state.videoGoLiver = action.payload
      state.hasNextPage = action.payload.hasNextPage
      action.payload.data.forEach((item : any) => state.videos.push(item))
    })
    builder.addCase(fetchStoreVideoGoLiverSummary.fulfilled, (state, action) => {
      state.countLiked = action.payload.countLiked
      state.countWantToTry = action.payload.countWantToTry
      state.countWantToEat = action.payload.countWantToEat
    })
  }
})

export const {
  setLoading,
  setPage,
  updateViewVideo
} = storeSlice.actions

export default storeSlice.reducer
